import {Injectable} from '@angular/core';
import { ODataEntitySetService, ODataServiceFactory } from 'angular-odata';
import {exportable$} from '../table/decorators/exportable';
import {Lqs} from '../../models/lqs';
import {ParentTableService} from '../table/parent-table.service';
import {map} from 'rxjs/operators';
import {ODataResponseMapper} from '../table/mappers/odata-response-mapper';
import {SQDataConfiguration} from '../table/configuration/OData-configuration';
import {HelperFunctions} from '../table/configuration/helper-functions';

@Injectable({
  providedIn: 'root'
})
export class SupplierLqsService extends ParentTableService {
  private odata: ODataEntitySetService<Lqs>;
  private config: SQDataConfiguration;
  @exportable$ lqs: any;


  constructor(private odataFactory: ODataServiceFactory) {
    super('SupplierLqsService');
    this.odata = this.odataFactory.entitySet<Lqs>('Overview(0)/LqsAssignment');
    this.config = new SQDataConfiguration();
  }

  getData(pageIndex, count, sortModel, filterModel) {
    const orders = [];
    sortModel.forEach(x => orders.push(x.colId.replace(/\./g, '/') + ' ' + x.sort));
    let filter = '';
    filter = HelperFunctions.addOdataFilters(filter, filterModel);

    const query = this.odata.entities().query(q => {
      q.top(count);
      q.skip(count * pageIndex);
      if (orders.length > 0) q.orderBy(orders);
      if (filter?.length) q.filter(filter);
      return q;
    });
    this.lqs = query;
    return this.lqs.fetch({ withCount: true }).pipe(map((r: any) => ODataResponseMapper.mapResponse(r)));
  }
}
